function camelCase(s) {
  return s.toLowerCase().replace(/-(.)/g, function (m, g) {
    return g.toUpperCase();
  });
} // Convert camel cased string to string seperated

function unCamelCase(s) {
  return s.replace(/([A-Z])/g, function (m, g) {
    return '-' + g.toLowerCase();
  });
}

/**
 * 判断是否含有指定类名
 */
function hasClass(el, cls) {
  if (!el || !cls) return false;

  if (cls.indexOf(' ') !== -1) {
    throw new Error('className should not contain space.');
  }
  //el.classList兼容性：[Chrome-8.0, IE-10.0, Firefox-3.6, Safari-5.1, Opera-11.5]
  if (el.classList) {
    return el.classList.contains(cls);
  }
  if (el.className == '') {
    return false;
  }
  return el.className.indexOf(cls) != -1;

}


/**
 * 添加类名
 */
function addClass(el, cls) {
  if (!el) return;

  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
};


/**
 * 移除类名
 */
function removeClass(el, cls) {
  if (!el || !cls) return;

  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }

};


/**
 * 切换类名
 */
function toggleClass(el, cls) {
  if (!el || !cls) return;

  if (hasClass(el, cls)) {
    removeClass(el, cls);
    return;
  }
  addClass(el, cls);

}


/**
 * 获取style值
 */
function getStyle(element, styleName) {
  if (!element || !styleName) return null;

  const ieVersion = Number(document.documentMode);
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = ieVersion < 9 ? 'styleFloat' : 'cssFloat';
  }

  if (ieVersion < 9) {
    try {
      switch (styleName) {
        case 'opacity':
          try {
            return element.filters.item('alpha').opacity / 100;
          } catch (e) {
            return 1.0;
          }
        default:
          return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
      }
    } catch (e) {
      return element.style[styleName];
    }
  } else {
    try {
      var computed = document.defaultView.getComputedStyle(element, '');
      return element.style[styleName] || computed ? computed[styleName] : null;
    } catch (e) {
      return element.style[styleName];
    }
  }
};


/**
 * 设置style值
 */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  const ieVersion = Number(document.documentMode);

  if (typeof styleName === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

